export const alignNumber = (number, precision) => number.toFixed(precision).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const wrapNegativeAndAlign = (num, precision = 2) => num >= 0
  ? `$${alignNumber(num, precision)}`
  : `($${alignNumber(Math.abs(num), precision)})`;

export const resourceRequestNumberTemplate = (requestId) =>(`RSRQ-${('000000'+requestId).slice(-7)}`);

export const dataImportSessionNumberTemplate = (requestId) =>(`DIS-${('000000'+requestId).slice(-7)}`);